import { useParams } from 'react-router-dom'
import ModalDeleteFilled from '../../../../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../../../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'

interface ModalDeleteWarehouseWorkingCenterProps extends ModalEditComponentProps { }

const ModalDeleteWarehouseWorkingCenter: React.FC<ModalDeleteWarehouseWorkingCenterProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const params = useParams<{ id: string }>()
    const id = params.id
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/workingCenter/workingCenterWarehouse/removeWorkingCenterToWarehouse',
        data: {
            WarehouseId: allRowData?.id,
            WorkingCenterId: id
        }
    })
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureDeleteWarehouseWorkingCenter', '¿Seguro quieres eliminar este almacen de este Centro de trabajo?'),
            subtitle: t('onceDeletedNotRecoverM', 'Una vez eliminado no podrás recuperarlo')
        }} />
    )
}

export default ModalDeleteWarehouseWorkingCenter